import { ExternalFeatureCode, ExternalFeatureDependency, ExternalFeatureTypes, PermissionTypeDto } from "../enums";

export interface ExternalFeature {
  id: ExternalFeatureTypes;
  code: ExternalFeatureCode; // Backend: value of Map<ExternalFeatureTypes, string>
  name: string;
  platformId: number;
  categoryId: number;
  platform: PlatformLegacyInterface; // client legacy property
  url: string;
  permission: PermissionTypeDto;
  urlOpenMode: UrlOpenModeDto;
}

export interface ExternalFeatureWithDependencyGetDto extends ExternalFeature {
  dependency: ExternalFeatureDependency;
}

export interface PlatformLegacyInterface {
  id: number;
  accountId: string;
  code: string;
  authorizationUrl: string;
  name: string;
}

export enum UrlOpenModeDto {
  NewTab = "NewTab",
  IFrame = "IFrame"
}
